export const API_URL = process.env.REACT_APP_APIURL;
export const backEnd = API_URL + '/app/api';